import React from 'react';
import axios from 'axios';
import pick from 'lodash/pick';
import MtMap from './mtmap';
import styles from './rule-map.less';

const createApi = () => axios.create({});

export default class RuleMap extends React.Component {
  constructor(props) {
    super(props);
    this.map = null;
    this.state = {
      currentRule: this.props.checkRules.default,
      mapCheck: {
        inWaterCheck: 1,
        crossRoadCheck: 1,
      },
      lastMoveSource: 'initial',
    };
  }

  componentDidMount() {
    this.map = new MtMap({
      el: '#map-container',
      beta: true,
      zoom: 16,
      $api: createApi(),
      center: [this.props.lng || 0, this.props.lat || 0],
      coordinateCheckApi: 'https://a.dper.com/poi/sales/geo/check',
      event: {
        dragend: this.onDragend.bind(this),
      },
      plugins: ['PanControl'],
      enableZoomControl: true,
      enableScaleControl: true,
      overseasFlag: this.props.overseasFlag,
      extraMapOption: {
        enableKeyboard: false,
        draggable: false,
        scrollwheel: false,
        enableDblclickZoom: false,
        touchZoom: false,
        touchZoomCenter: true,
      },
      created: () => {
        this.toggleEdit(this.props.editable);
        this.map.mapInstance.on('zoomend', async event => {
          if (typeof this.props.onZoom === 'function') this.props.onZoom(event);
        });
      },
    });
  }

  onDragend(data) {
    this.setState(
      {
        mapCheck: {
          ...pick(data, ['inWaterCheck', 'crossRoadCheck']),
        },
        lastMoveSource: data.source,
      },
      () => {
        const currentRule = this.refreshRule();
        this.setState({
          currentRule,
          currentLocation: data.center,
        });
        this.props.onChange({
          location: {
            lng: data.center.lng,
            lat: data.center.lat,
          },
          canSubmit: currentRule.canSubmit !== false,
        });
      }
    );
  }

  toggleEdit(editable) {
    if (editable) {
      this.map.mapInstance.setStatus({
        enableKeyboard: true,
        draggable: true,
        scrollwheel: true,
        enableDblclickZoom: true,
        touchZoom: true,
      });
    } else {
      this.map.mapInstance.setStatus({
        enableKeyboard: false,
        draggable: false,
        scrollwheel: false,
        enableDblclickZoom: false,
        touchZoom: false,
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { editable, status } = this.props;
    if (editable !== prevProps.editable) {
      this.toggleEdit(editable);
    }
    if (status !== prevProps.status) {
      this.setState(
        {
          lastMoveSource: status,
        },
        () => {
          this.setState({
            currentRule: this.refreshRule(),
          });
        }
      );
    }
  }

  refreshRule() {
    const { checkRules } = this.props;
    let currentRule = checkRules.default;
    Object.keys(checkRules).forEach(key => {
      if (key === 'default') return;
      const newRule = checkRules[key];
      if (this.state.mapCheck[key] === 0 || this.state.lastMoveSource === key) {
        if (newRule.priority > currentRule.priority) {
          currentRule = newRule;
        }
      }
    });

    return currentRule;
  }

  render() {
    const { currentRule } = this.state;

    return (
      <div className={styles.mapPickerOuter}>
        <div className={styles.mapPinOuter}>
          <div
            className={`
            ${styles.mapPinText}
            ${currentRule.level === 'warn' ? styles.mapPinTextWarn : ''}
          `}
          >
            {currentRule.text}
          </div>
          <img
            className={styles.mapPin}
            src="https://p0.meituan.net/ingee/0ee919bb057a3d30e25964c70f3dfaba1523.png"
            alt="pin"
          />
        </div>
        <div id="map-container" className={styles.mapContainer} />
      </div>
    );
  }
}
